import { Injectable } from "@angular/core";
import { ImageSEO } from "../models/image-seo.model";
import { SiilaTranslationService } from "./siila-translation.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class StaticImagesSEOService {
  currentCode: string;

  constructor(private ts: SiilaTranslationService) {
    this.currentCode = environment.platformId;
  }

  getSiilaBrandSEOInfo(): ImageSEO {
    const titleKey = "siilabrand";
    const staticImg = "assets/img/SiiLA_SVG.svg";
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getMarketAnalyticsRealIntelligenceSEO(): ImageSEO {
    const titleKey = "marketAnalyticsRealIntelligence";
    const staticImg = this.getImgBannerMarket();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getMultifamilySEO(): ImageSEO {
    const titleKey = "multifamilyText";
    const staticImg = this.getImgBannerMarket();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getAcademyImgSEO(): ImageSEO {
    const titleKey = "academyImg";
    const staticImg = this.getImgBannerAcademy();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getSpotTransformingExperienceSEO(): ImageSEO {
    const titleKey = "spotTransformingExperience";
    const staticImg = this.getSpotTransformingExperienceImg();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getCommercialestatenewslatam(): ImageSEO {
    const titleKey = "commercialestatenewslatam";
    const staticImg = this.imgNewMobile();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getLinkedinSEO(): ImageSEO {
    const titleKey = "socialmedia.linkedin";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getTikTokSEO(): ImageSEO {
    const titleKey = "socialmedia.tiktok";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getYoutubeSEO(): ImageSEO {
    const titleKey = "socialmedia.youtube";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getFacebookSEO(): ImageSEO {
    const titleKey = "socialmedia.facebook";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getInstagramSEO(): ImageSEO {
    const titleKey = "socialmedia.instagram";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getTwitterSEO(): ImageSEO {
    const titleKey = "socialmedia.twitter";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareWhatsappSEO(): ImageSEO {
    const titleKey = "sharesocial.whatsapp";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareEmailSEO(): ImageSEO {
    const titleKey = "sharesocial.email";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareFacebookSEO(): ImageSEO {
    const titleKey = "sharesocial.facebook";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareLinkedinSEO(): ImageSEO {
    const titleKey = "sharesocial.linkedin";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  private getImgBannerMarket() {
    if (
      this.currentCode == "mx" ||
      this.currentCode == "latam" ||
      this.currentCode == "co"
    ) {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/Frame 574.jpg"
        : "../../../../assets/img/BANNER MA - RESOURCE.png";
    } else {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/Multifamily-Banner-EN.png"
        : "../../../../assets/img/Multifamily-Banner-PT.png";
    }
  }

  private getImgBannerAcademy() {
    if (
      this.currentCode == "mx" ||
      this.currentCode == "latam" ||
      this.currentCode == "co"
    ) {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/EN - BANNER ACADEMY ADVANCED 2024.png"
        : "../../../../assets/img/PT - BANNER ACADEMY ADVANCED 2024.png";
    } else {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/EN - BANNER ACADEMY ADVANCED 2024.png"
        : "../../../../assets/img/PT - BANNER ACADEMY ADVANCED 2024.png";
    }
  }

  private getSpotTransformingExperienceImg() {
    if (
      this.currentCode == "mx" ||
      this.currentCode == "latam" ||
      this.currentCode == "co"
    ) {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/MX EN VERSION.png"
        : "../../../../assets/img/SP VERSION.png";
    } else {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/Card.jpg"
        : "../../../../assets/img/PT VERSION.png";
    }
  }

  imgNewMobile() {
    let img = "../../../../assets/img/products-list/";
    if (this.currentCode == "mx" || this.currentCode == "co") {
      if (this.ts.getCurrentLanguage() == "en") {
        img = img + "IPHONE14_EN.png";
      } else {
        img = img + "IPHONE14_ES.png";
      }
    } else {
      if (this.ts.getCurrentLanguage() == "en") {
        img = img + "IPHONE14_EN.png";
      } else {
        img = img + "IPHONE14_PT.png";
      }
    }

    return img;
  }

  getBannerOdd(): ImageSEO {
    return this.getBannerByRotation("odd");
  }

  getBannerPairs(): ImageSEO {
    return this.getBannerByRotation("pair");
  }

  private getBannerByRotation(type: "odd" | "pair"): ImageSEO {
    const count = localStorage.getItem("bannerCount");
    const rotation = this.getRotationNumber(count, type);
    const imgPath = this.resolveImagePath(rotation);
    const title = this.resolveTitle(rotation);
    return this.setBannerTitle(title, imgPath);
  }

  private resolveTitle(rotation: number): string {
    return this.ts.getTranslationFromJSONFiles(
      `imgSEO.imgBanner.${rotation}.title`
    );
  }

  private getRotationNumber(
    count: string | null,
    type: "odd" | "pair"
  ): number {
    const rotationMap = {
      odd: { "1": 1, "2": 3, "3": 5 },
      pair: { "1": 2, "2": 4, "3": 6 }
    };
    return rotationMap[type][count || "1"];
  }

  private resolveImagePath(rotation: number) {
    const img = "../../../../assets/img/";
    const lang = this.ts.getCurrentLanguage();
    const code = this.currentCode;

    const banners = {
      br: {
        1: {
          en: "Multifamily-Banner-EN.png",
          pt: "Multifamily-Banner-PT.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        2: {
          en: "Zolver Banner EN.png",
          pt: "Zolver Banner PT.png",
          link: {
            en: "https://spot.siila.com.br/company/zolver/34161272/en",
            pt: "https://spot.siila.com.br/empresa/zolver/34161272/pt-br"
          }
        },
        3: {
          en: "caprigtEn.png",
          pt: "caprigtPt.png",
          link: {
            en: "https://www.capright.com/",
            pt: "https://www.capright.com/pt/"
          }
        },
        4: {
          en: "retha_siila_-_en.gif",
          pt: "retha_siila_-_pt.gif",
          link: "https://retha.com.br"
        },
        5: {
          en: "Zolver Banner EN.png",
          pt: "Zolver Banner PT.png",
          link: {
            en: "https://spot.siila.com.br/company/zolver/34161272/en",
            pt: "https://spot.siila.com.br/empresa/zolver/34161272/pt-br"
          }
        },
        6: {
          en: "retha_siila_-_en.gif",
          pt: "retha_siila_-_pt.gif",
          link: "https://retha.com.br/"
        }
      },
      mx: {
        1: {
          en: "Frame 574.jpg",
          es: "BANNER MA - RESOURCE.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        2: {
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        },
        3: {
          en: "Frame 574.jpg",
          es: "BANNER MA - RESOURCE.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        4: {
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        },
        5: {
          en: "Frame 574.jpg",
          es: "BANNER MA - RESOURCE.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        6: {
          en: "caprigtEn.png",
          es: "caprigtEs es.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        }
      },
      latam: {
        1: {
          en: "Frame 574.jpg",
          es: "BANNER MA - RESOURCE.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        2: {
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        },
        3: {
          en: "Frame 574.jpg",
          es: "BANNER MA - RESOURCE.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        4: {
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        },
        5: {
          en: "Frame 574.jpg",
          es: "BANNER MA - RESOURCE.png",
          link: "mailchi.mp/siila.com.br/multifamily"
        },
        6: {
          en: "caprigtEn.png",
          es: "caprigtEs es.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        }
      }
    };

    const banner = banners[code]?.[rotation];
    const imgName = banner?.[lang] || "default.png";
    const rawLink = banner?.link;

    let resolvedLink = "";
    if (typeof rawLink === "string") {
      resolvedLink = rawLink;
    } else if (typeof rawLink === "object" && rawLink !== null) {
      resolvedLink = rawLink[lang] || "";
    }

    return {
      img: img + imgName,
      link: resolvedLink
    };
  }

  private findTitleTranslation(titleKey: string, staticImg?: string) {
    const title = this.ts.getTranslationFromJSONFiles(
      `imgSEO.${titleKey}.title`
    );

    let result: ImageSEO = {
      src: staticImg,
      title: title,
      alt: title
    };
    return result;
  }

  private setBannerTitle(titleKey: string, staticImg?) {
    let result: ImageSEO = {
      src: staticImg.img,
      title: titleKey,
      alt: titleKey,
      link: staticImg.link
    };
    return result;
  }
}
